import React from 'react';
import { motion } from 'framer-motion';
import LazyImage from '../common/LazyImage';

// Image imports
import img1 from '../../assets/media/photos/skyford_gallery_photo_16.webp';
import img2 from '../../assets/media/photos/skyford_gallery_photo_2.webp';
import img3 from '../../assets/media/photos/skyford_gallery_photo_3.webp';
import img4 from '../../assets/media/photos/skyford_gallery_photo_1.webp';
import { Link } from 'react-router-dom';

const LifeAtSkyford = () => {

  return (
    <section className="py-5 sm:py-10 ">
      {/* Intro Section */}
      <div className="max-w-7xl mx-auto px-3 sm:px-6">
        <div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-8 sm:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-semibold text-gray-900 mb-4">Life at Skyford</h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Step into a world where innovation, collaboration, and culture blend seamlessly to create unforgettable experiences.
          </p>
        </div>

        {/* Image Gallery */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-6 mb-16">
          {[img1, img2, img3, img4].map((img, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              whileHover={{ scale: 1.05 }}
              transition={{ delay: index * 0.1, duration: 0.4 }}
              className=" relative rounded-xl overflow-hidden "
            >
              <LazyImage
                src={img}
                alt={`Skyford Campus ${index + 1}`}
                className="w-full h-full aspect-[4/3]"
              />
            </motion.div>
          ))}
        </div>

        {/* Video Section */}
        <div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h3 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">Feel the SKYFORD Spirit</h3>
          <p className="sm:text-lg text-gray-700 max-w-xl mx-auto mb-8 sm:mb-10">
            Watch our journey and immerse yourself in the vibrant culture of Skyford.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-8">
            {["https://youtube.com/embed/10krgTNKYQQ", "https://youtube.com/embed/X1WIuobQ1IY"].map((url, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.2, duration: 0.4 }}
                className="relative rounded-xl overflow-hidden "
              >
                <iframe
                  src={url}
                  title={`Skyford Video ${index + 1}`}
                  className="w-full h-60 sm:h-80 rounded-lg"
                  allowFullScreen
                />
              </motion.div>
            ))}
          </div>
        </div>

        {/* Call to Action Section */}
        <div
          className="bg-red-100 rounded-xl p-5 sm:p-12 text-center"
        >
          <h3 className="text-3xl sm:text-4xl font-semibold mb-4">Your Journey Begins Here!</h3>
          <p className="text-lg max-w-2xl mx-auto mb-8">
            Take the first step toward a transformative experience at Skyford.
          </p>
          <Link to='/contact'><button
            className="bg-white text-red-600 px-5 sm:px-8 py-3 sm:py-4 rounded-full font-medium sm:font-semibold"
          >
            Join the Family
          </button></Link>
        </div>
      </div>
    </section>
  );
};

export default LifeAtSkyford;
